import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ProductFilledSvg from "@ant-design/icons-svg/es/asn/ProductFilled";
import AntdIcon from "../components/AntdIcon";
var ProductFilled = function ProductFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ProductFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ProductFilled.displayName = 'ProductFilled';
}
export default /*#__PURE__*/React.forwardRef(ProductFilled);